import type { Polygon as LeafletPolygon } from 'leaflet';

export type GeoJsonPolygon = {
  type: 'Polygon';
  coordinates: number[][][];
};

function ringArea(ring: number[][]): number {
  let area = 0;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i]?.[0] ?? 0;
    const yi = ring[i]?.[1] ?? 0;
    const xj = ring[j]?.[0] ?? 0;
    const yj = ring[j]?.[1] ?? 0;
    area += (xj + xi) * (yj - yi);
  }
  return Math.abs(area / 2);
}

export function geometryAreaDeg2(geometry: {
  type: string;
  coordinates: unknown;
}): number {
  if (geometry.type !== 'Polygon') return Number.POSITIVE_INFINITY;
  const ring = (geometry.coordinates as number[][][])?.[0];
  return ring ? ringArea(ring) : Number.POSITIVE_INFINITY;
}

/** Rough m² at ~33°N. */
export function approximateAreaSqm(areaDeg2: number): number {
  return Math.round(areaDeg2 * 111_320 * 93_000);
}

export function centroidFromGeometry(geometry: {
  type: string;
  coordinates: unknown;
}): { lat: number; lng: number } {
  const ring =
    geometry.type === 'Polygon'
      ? (geometry.coordinates as number[][][])?.[0]
      : null;
  if (!ring?.length) {
    return { lat: 32.84, lng: 35.63 };
  }
  let sumLat = 0;
  let sumLng = 0;
  for (const coord of ring) {
    sumLng += coord[0] ?? 0;
    sumLat += coord[1] ?? 0;
  }
  const n = ring.length;
  return { lat: sumLat / n, lng: sumLng / n };
}

export function leafletLayerToGeoJsonPolygon(
  layer: LeafletPolygon,
): GeoJsonPolygon | null {
  const gj = layer.toGeoJSON();
  if (gj.type !== 'Feature' || gj.geometry.type !== 'Polygon') {
    return null;
  }
  return gj.geometry as GeoJsonPolygon;
}
